import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14be283e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "matchSchedule" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "matchScheduleFull" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "center display-2" }, "Todays Match")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "matchScheduleMobile" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "center display-5" }, "Todays Match")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "layout gutter--md"
}
const _hoisted_5 = { class: "searchControls row row align--center justify--space-around mb-4" }
const _hoisted_6 = { class: "md2 flex mobile sm1" }
const _hoisted_7 = { class: "md3 flex xs12 sm4" }
const _hoisted_8 = {
  key: 1,
  class: "layout gutter--xl"
}
const _hoisted_9 = { class: "row justify--center tournamentContainer" }
const _hoisted_10 = {
  class: "blockSpace",
  style: {"font-size":"x-large"}
}
const _hoisted_11 = { class: "blockSpace" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"accordion-header-name\" data-v-14be283e><h4 class=\"column\" data-v-14be283e>KAMP NR</h4><h4 class=\"column\" data-v-14be283e>HJEMMEHOLD</h4><h4 class=\"column\" data-v-14be283e>UDEHOLD</h4><h4 class=\"column\" data-v-14be283e>RESULTAT</h4></div>", 1)
const _hoisted_13 = { class: "accordion-header" }
const _hoisted_14 = { class: "column" }
const _hoisted_15 = { class: "column" }
const _hoisted_16 = { class: "column" }
const _hoisted_17 = { class: "column with-actions" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Detaljer")
const _hoisted_19 = { key: 2 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify--space-around" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Ingen kampe ser ud til at være startet endnu.")
    ])
  ])
], -1))
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (Object.keys(_ctx.forFilterMatchData).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_va_button, {
                class: "btn",
                color: "#b4003a",
                rounded: false,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.columnSort('reset')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_va_icon, {
                    class: "reset",
                    name: "autorenew"
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_va_select, {
                label: "Filtrer efter klub",
                modelValue: _ctx.filterByClubValue,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterByClubValue) = $event)),
                options: _ctx.filterByClubOptions,
                searchable: "",
                bordered: ""
              }, null, 8, ["modelValue", "options"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (Object.keys(_ctx.todayMatchData).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.todayMatchData, (mainValue, mainName, mainIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: mainIndex,
                style: {"width":"100%"}
              }, [
                _createElementVNode("h2", _hoisted_10, _toDisplayString(mainName), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainValue, (value, name, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createElementVNode("h4", _hoisted_11, _toDisplayString(name), 1),
                    _hoisted_12,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (teamData, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, _toDisplayString(teamData.kampnr), 1),
                          _createElementVNode("div", _hoisted_15, _toDisplayString(teamData.homeTeamName), 1),
                          _createElementVNode("div", _hoisted_16, _toDisplayString(teamData.awayTeamName), 1),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("span", null, _toDisplayString(teamData.homeTeamResult) + " - " + _toDisplayString(teamData.awayTeamResult), 1),
                            _createVNode(_component_router_link, {
                              to: ('/turneringer/kampseddel/' + Number(teamData.matchId))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_18
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                }), 128))
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
  ]))
}